// extracted by mini-css-extract-plugin
module.exports = {"link":"TextItem__link--blue--3i28c","item":"TextItem__item--blue--2T-VO","isSubmenuOpen":"TextItem__isSubmenuOpen--blue--2FjJ9","isActive":"TextItem__isActive--blue--3eW5T"};
    if(module.hot) {
      // 1605595234886
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  